/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import classNames from 'classnames';

import { QUERY_PARAMS } from '@futrli/shared-services';

import * as styles from '../onboarding-nav.scss';
import { BUDGET_ONBOARDING_STEP } from '../const';
import { NewAssumptionButton } from '../../detail/predictions/components/new-assumption-button';
import { ForecastingMenu } from '../../detail/predictions/predictions-nav-data-controls/forecasts-menu';
import { ForecastType } from '../shared/onboarding-type-select';

export const BudgetOnboardingNav = () => {
  const { onboardingStep: tempOnboardingStep } = useParams();
  const onboardingStep = tempOnboardingStep as BUDGET_ONBOARDING_STEP;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const forecastType = searchParams.get(QUERY_PARAMS.FORECAST_TYPE);

  let budgetSteps;
  switch (forecastType) {
    case ForecastType.FromLYA:
      budgetSteps = 7;
      break;
    case ForecastType.WithAutoPredictions:
      budgetSteps = 8;
      break;
    case ForecastType.FromScratch:
      budgetSteps = 6;
      break;
    default:
      budgetSteps = 7;
      break;
  }

  const initialWidth = 100 / budgetSteps;
  const onboardingStepNum = onboardingStep ? Number(onboardingStep) : 0;
  const currentWidth = (onboardingStepNum + 1) * initialWidth;

  const showManualPredictionButton =
    (onboardingStepNum >= Number(BUDGET_ONBOARDING_STEP.SCRATCH_CUSTOMISE) &&
      forecastType === ForecastType.FromScratch) ||
    (onboardingStepNum >= Number(BUDGET_ONBOARDING_STEP.LYA_CUSTOMISE) && forecastType === ForecastType.FromLYA) ||
    (onboardingStepNum >= Number(BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_CUSTOMISE) &&
      forecastType === ForecastType.WithAutoPredictions);

  const showForecastingMenu =
    (onboardingStepNum >= Number(BUDGET_ONBOARDING_STEP.SCRATCH_ADDITIONAL_CONTROLS) &&
      forecastType === ForecastType.FromScratch) ||
    (onboardingStepNum >= Number(BUDGET_ONBOARDING_STEP.LYA_ADDITIONAL_CONTROLS) &&
      forecastType === ForecastType.FromLYA) ||
    (onboardingStepNum >= Number(BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_ADDITIONAL_CONTROLS) &&
      forecastType === ForecastType.WithAutoPredictions);

  const newAssumptionButtonIsOpen =
    (forecastType === ForecastType.FromScratch &&
      onboardingStepNum === Number(BUDGET_ONBOARDING_STEP.SCRATCH_CUSTOMISE)) ||
    (forecastType === ForecastType.FromLYA && onboardingStepNum === Number(BUDGET_ONBOARDING_STEP.LYA_CUSTOMISE)) ||
    (forecastType === ForecastType.WithAutoPredictions &&
      onboardingStepNum === Number(BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_CUSTOMISE));

  return (
    <>
      <nav className={styles.navContainer}>
        {showForecastingMenu ? (
          <ForecastingMenu />
        ) : (
          <div className={styles.forecastControlsPlaceholder} style={{ marginRight: 30 }} />
        )}
        <div className={styles.divider} />
        {showManualPredictionButton ? (
          <div style={{ marginLeft: 'auto' }}>
            <NewAssumptionButton isOpenInitially={newAssumptionButtonIsOpen} />
          </div>
        ) : (
          <div className={styles.newPredictionPlaceholder} style={{ marginLeft: 'auto' }} />
        )}
        <div style={{ width: 9 }} />
        <div className={styles.providerPlaceholder} />
      </nav>
      <div className={styles.progressiveBarContainer}>
        <div className={classNames(styles.progressBar)} style={{ width: `${currentWidth}%` }} />
      </div>
    </>
  );
};
